export default __webpack_public_path__ + "static/media/Grid-white.a7c628ac.svg";